import { defineStore } from 'pinia'

import type { PaymentsStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const usePaymentsStore = defineStore('payments', {
  state: (): PaymentsStore => ({
    paymentMethodsLoading: false,
    paymentMethodsListLoading: false,
    paymentMethods: [],
    subscriptionsLoading: false,
    subscriptions: [],
    modalChangeDefaultCreditCard: null,
    modalDeleteCreditCard: null,
    modalAddCreditCard: false,
    merchantData: null,
    stripeSetupSecret: null,
    ordersLoading: false,
    loading: false,
    orders: null,
    modalRefund: null,
  }),
  actions,
  getters,
})
